import { useCallback, useRef } from "react";
import { useTranslation } from "@xkit-yx/im-kit-ui";

const EMOJI_LIST_KEYS = [
  "Laugh","Happy","Sexy","Cool","Mischievous","Kiss","Spit","Squint","Cute","Grimace",
  "Snicker","Joy","Ecstasy","Surprise","Tears","Sweat","Angle","Funny","Awkward","Thrill",
  "Cry","Fretting","Terrorist","Halo","Shame","Sleep","Tired","Mask","ok","AllRight",
  "Despise","Uncomfortable","Disdain","ill","Mad","Ghost","Angry","Unhappy","Frown",
  "Broken","Beckoning","Ok","Low","Nice","Applause","GoodJob","Hit","Please","Bye",
  "First","Fist","GiveMeFive","Knife","Hi","No","Hold","Think","Pig","NoListen",
  "NoLook","NoWords","Monkey","Bomb","Cloud","Rocket","Ambulance","Poop",
];

const EMOJI_ICON_IDS = [
  "icon-a-1","icon-a-2","icon-a-3","icon-a-4","icon-a-5","icon-a-6","icon-a-7",
  "icon-a-8","icon-a-9","icon-a-10","icon-a-11","icon-a-12","icon-a-13","icon-a-14",
  "icon-a-15","icon-a-16","icon-a-17","icon-a-18","icon-a-19","icon-a-20","icon-a-21",
  "icon-a-22","icon-a-23","icon-a-24","icon-a-25","icon-a-26","icon-a-27","icon-a-28",
  "icon-a-29","icon-a-30","icon-a-31","icon-a-32","icon-a-33","icon-a-34","icon-a-35",
  "icon-a-36","icon-a-37","icon-a-38","icon-a-39","icon-a-40","icon-a-41","icon-a-42",
  "icon-a-43","icon-a-44","icon-a-45","icon-a-46","icon-a-47","icon-a-48","icon-a-49",
  "icon-a-50","icon-a-51","icon-a-52","icon-a-53","icon-a-54","icon-a-55","icon-a-56",
  "icon-a-57","icon-a-58","icon-a-59","icon-a-60","icon-a-61","icon-a-62","icon-a-63",
  "icon-a-64","icon-a-65","icon-a-66","icon-a-67","icon-a-68","icon-a-70",
];

export default function useEmojiConfig() {
  const { t } = useTranslation();
  // 缓存构建结果：t 不变则直接返回同一对象，避免每次调用都重建 Map 和 RegExp
  const cacheRef = useRef(null);
  const tRef     = useRef(null);

  const getEmojiConfig = useCallback(() => {
    if (cacheRef.current && tRef.current === t) return cacheRef.current;
    tRef.current = t;
    const EMOJI_ICON_MAP_CONFIG = {};
    EMOJI_LIST_KEYS.forEach((key, idx) => {
      EMOJI_ICON_MAP_CONFIG[t(key)] = EMOJI_ICON_IDS[idx] || `icon-a-${idx + 1}`;
    });
    const INPUT_EMOJI_SYMBOL_REG = new RegExp(
      "(" +
        Object.keys(EMOJI_ICON_MAP_CONFIG)
          .map((item) => {
            const left = `\\${item.slice(0, 1)}`;
            const right = `\\${item.slice(-1)}`;
            const mid = item.slice(1, -1);
            return `${left}${mid}${right}`;
          })
          .join("|") +
        ")",
      "g"
    );
    cacheRef.current = { EMOJI_ICON_MAP_CONFIG, INPUT_EMOJI_SYMBOL_REG };
    return cacheRef.current;
  }, [t]);
  return { getEmojiConfig };
}
